<template>
  <el-dialog
    class="dialog"
    title="资源配置"
    width="60%"
    :visible.sync="showSelect.flag"
    @close="cancelSelcet"
  >
    <div>
      <!--操作栏-->
      <div class="search_right search_content">
        <el-input
          prefix-icon="el-icon-search"
          v-model="query"
          placeholder="资源名称"
          class="name"
        ></el-input>

        <butn class="mlButn" btntype="primary" title="查询" @click="search"></butn>
        <butn class="czButn" title="重置" @click="resetData" ></butn>

      </div>
      
      <!--表格内容栏-->
      <el-table
          ref="pageListTable"
          border
          :data="resourseData"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400,}"
          :header-cell-style="{
            background: '#DCE7FA',
            color: '#343C4A',
            fontWeight: 500,
          }"
          @selection-change="handleSelectionChanges"
        >
          <el-table-column
            type="selection"
            :selectable="selectInit"
            :reserve-selection="true"
            width="40"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="资源名称"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="ellipsis--l2">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="bizTypeName"
            label="类型"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="onlineDate"
            label="上线时间"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      <!--分页栏-->
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="page"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    <span slot="footer" class="dialog-footer">
      <el-checkbox class="set-new" v-model="isSetNew">同时设为最新</el-checkbox>
      <el-button @click="cancelSelcet" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { findSubjectResources } from "@/api/configInfo";
import {
getRBooks, getRNews, getRRArticles, getRVideo, getSubjectBlockInfo, saveSubjectConfig
} from "@/api/subjectBlockConfig";
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    bizType: {
      type: Number,
      default: () => 1,
    },
    showSelect: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    subjectId: {
      type: String,
      default: "",
    },
    subjectBlockId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      query: "",
      page: 1,
      size: 10,
      total: 0,
      subjectBlockConfigList: [],
      resourseData: [],
      selectedResourses: [],
      hasResourses: [],
      isSetNew: false,
    };
  },
  created() {
    this.getConfig(this.subjectBlockId);
  },
  methods: {
   
    /****** Search */
    search() {
      this.page = 1;
      this.getList();
    },
    resetData() {
      this.page = 1;
      this.query = '';
      this.getList();
    },

    
    getList() {
      findSubjectResources({
        page: this.page,
        limit: this.size,
        bizType: this.blockType,
        keyWord: this.query,
      }).then(({ code, data }) => {
        if (code !== 0) return;
        this.total = data.total;
        this.resourseData = data.records || [];
        this.resourseData.map((v) => {
          this.hasResourses.map((i) => {
            if (v.uuid == i) {
              v.disabled = true;
              this.$refs.pageListTable.toggleRowSelection(v);
            }
          });
        });
      });
    },
    getConfig(id) {
      //查询版块信息-->获取对应类型-->根据对应类型查询数据
      getSubjectBlockInfo(id).then((res) => {
        if (!res || res.code != 0) return;
        this.blockType = res.data.blockType;
        //根据不同板块业务类型： 0视频 1新闻 2图书 3期刊文章 查询列表
        if (this.blockType === 0) {
          //初始已关联节点
          getRVideo(id).then((res) => {
            if (!res || res.code != 0) return;
            this.getInitList(res.data || [])
          });
        } else if (this.blockType === 1) {
          getRNews(id).then((res) => {
            if (!res || res.code != 0) return;
            this.getInitList(res.data || [])
          });
        } else if (this.blockType === 2) {
          getRBooks(id).then((res) => {
            if (!res || res.code != 0) return;
            this.getInitList(res.data || [])
          });
        } else if (this.blockType === 3) {
          getRRArticles(id).then((res) => {
            if (!res || res.code != 0) return;
            this.getInitList(res.data || [])
          });
        }
      });
    },
    getInitList(val) {
      this.hasResourses = val.map((ele) => ele.uuid);
      this.getList();
    },
    cancelSelcet() {
      this.$emit("closeSelect", false);
    },
    confirm() {
      let realSelectData = this.selectedResourses.filter(v => !this.hasResourses.includes(v.uuid))
      if (realSelectData.length == 0) {
        this.$message({
          message: "请选择至少一条资源",
          type: "warning",
        });
      } else {
        //组装数据
        let subjectBlockConfigList = realSelectData.map((val) => {
          return {
            bizId: val.uuid,
            subjectId: this.subjectId,
            subjectBlockId: this.subjectBlockId,
          };
        });
        saveSubjectConfig({
          subjectBlockId: this.subjectBlockId,
          subjectBlockConfigList,
          isNew: this.isSetNew ? 1 : 0,
        })
          .then((res) => {
            if (!res || res.code != 0) return;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("closeSelect", true);
            }
          });
      }
    },

    /******TABLE */
    pageChange(page) {
      this.page = page
      this.getList();
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    selectInit(row) {
      return !row.disabled;
    },
    handleSelectionChanges(val) {
      this.selectedResourses = val;
    },

  },
};
</script>

<style lang="scss" scoped>
$text-color: #51627d;
$text-font: 14px;

/deep/ .el-pagination {
  text-align: right !important;
}

.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    padding: 20px;
    .search_content {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .mlButn{
      margin-left: 10px;
    }

  }

  .pagination {
    margin-top: 14px;
  }
  .set-new {
    margin-right: 16px;
  }
}
</style>
